export default __webpack_public_path__ + "static/media/HoldWhite.9c3ff34a.svg";